export type CtaPlacement =
  | 'header_access'
  | 'hero_badge'
  | 'hero_primary'
  | 'cards_ready_begin'
  | 'ribbon_cta'
  | 'ready_to_begin'
  | 'community_books'
  | 'bottom_cta'
  | 'footer_join';

type TrackCtaClickParams = {
  placement: CtaPlacement;
  language: string;
  destination: string;
  hasAnalyticsConsent: boolean;
};

type TrackingWindow = Window & {
  dataLayer?: Array<Record<string, unknown> | unknown[]>;
  clarity?: (...args: unknown[]) => void;
  __clarityLoaded?: boolean;
};

const CTA_EVENT_BY_PLACEMENT: Record<CtaPlacement, string> = {
  header_access: 'header_cta_click',
  hero_badge: 'hero_badge_click',
  hero_primary: 'hero_cta_click',
  cards_ready_begin: 'cards_cta_click',
  ribbon_cta: 'ribbon_cta_click',
  ready_to_begin: 'ready_to_begin_click',
  community_books: 'community_books_click',
  bottom_cta: 'bottom_cta_click',
  footer_join: 'footer_cta_click',
};

const getDeviceType = (): 'mobile' | 'tablet' | 'desktop' | 'unknown' => {
  if (typeof window === 'undefined') return 'unknown';
  const width = window.innerWidth;
  if (width < 640) return 'mobile';
  if (width < 1024) return 'tablet';
  return 'desktop';
};

export const trackCtaClick = ({
  placement,
  language,
  destination,
  hasAnalyticsConsent,
}: TrackCtaClickParams): void => {
  if (typeof window === 'undefined') return;
  if (!hasAnalyticsConsent) return;

  const w = window as TrackingWindow;
  const eventName = CTA_EVENT_BY_PLACEMENT[placement];
  const payload = {
    event: eventName,
    event_type: 'cta_click',
    placement,
    lang: language,
    device: getDeviceType(),
    page_path: window.location.pathname,
    destination,
  };

  w.dataLayer = w.dataLayer || [];
  w.dataLayer.push(payload);

  if (w.__clarityLoaded && typeof w.clarity === 'function') {
    w.clarity('event', eventName);
  }
};
